import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message, Popconfirm } from "antd";
import { store } from '../../../app/store';
import { ServicesConfig } from "../../../service/servicesConfig";

const MapManager = () => {
  const [maps, setMaps] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingMap, setEditingMap] = useState(null);
  const [form] = Form.useForm();

  const baseURL = ServicesConfig.getBaseUrlV2()  + "/admin/map"; // Base URL para SGVMAP_MAPController


  const getAuthorization = () => {
    const state = store.getState();
    return state.user.logged ? "Bearer " + state.user.token : ""
  }

  // Obtener la lista de mapas
  const fetchMaps = async () => {
    try {
      const response = await fetch(`${baseURL}/list`, {
        headers: { Authorization: getAuthorization() },
      }); // Endpoint para obtener todos los mapas
      if (!response.ok) throw new Error("Error al obtener los mapas");
      const data = await response.json();
      setMaps(data);
    } catch (error) {
      message.error("Error al obtener la lista de mapas");
      console.error(error);
    }
  };

  // Crear o actualizar un mapa
  const handleSaveMap = async (values) => {
    const method = editingMap ? "PUT" : "POST";
    const url = editingMap
      ? `${baseURL}/update/${editingMap.idMap}`
      : `${baseURL}/create`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
        body: JSON.stringify(values),
      });
      if (!response.ok) throw new Error("Error al guardar el mapa");

      message.success(
        editingMap
          ? "Mapa actualizado correctamente"
          : "Mapa creado correctamente"
      );
      fetchMaps();
      setIsModalOpen(false);
      setEditingMap(null);
      form.resetFields();
    } catch (error) {
      message.error("Error al guardar el mapa");
      console.error(error);
    }
  };

  // Eliminar un mapa
  const handleDeleteMap = async (idMap) => {
    try {
      const response = await fetch(`${baseURL}/delete/${idMap}`, {
        method: "DELETE",
        headers: {
          Authorization: getAuthorization(),
        },
      });
      if (!response.ok) throw new Error("Error al eliminar el mapa");

      message.success("Mapa eliminado correctamente");
      fetchMaps();
    } catch (error) {
      message.error("Error al eliminar el mapa");
      console.error(error);
    }
  };

  // Abrir modal para edición
  const handleEdit = (map) => {
    setEditingMap(map);
    form.setFieldsValue(map);
    setIsModalOpen(true);
  };

  // Abrir modal para crear
  const handleCreate = () => {
    setEditingMap(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchMaps();
  }, []);

  const columns = [
    {
      title: "ID Mapa",
      dataIndex: "idMap",
      key: "idMap",
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar este mapa?"
            onConfirm={() => handleDeleteMap(record.idMap)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Mapas</h1>
      <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
        Crear Mapa
      </Button>
      <Table columns={columns} dataSource={maps} rowKey="idMap" />

      <Modal
        title={editingMap ? "Editar Mapa" : "Crear Mapa"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveMap}
          initialValues={{ name: "", description: "", config: "" }}
        >

          <Form.Item
            name="idMap"
            label="ID Mapa"
            rules={[{ required: true, message: "Por favor, ingrese un ID Mapa" }]}
          >
            <Input placeholder="ID Mapa" />
          </Form.Item>

          <Form.Item
            name="name"
            label="Nombre"
            rules={[{ required: true, message: "Por favor, ingrese un nombre" }]}
          >
            <Input placeholder="Nombre del Mapa" />
          </Form.Item>
          <Form.Item
            name="description"
            label="Descripción"
            rules={[{ required: true, message: "Por favor, ingrese una descripción" }]}
          >
            <Input.TextArea placeholder="Descripción del Mapa" />
          </Form.Item>
          <Form.Item
            name="config"
            label="Configuración"
            rules={[{ required: false }]}
          >
            <Input.TextArea placeholder="Configuración (opcional)" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MapManager;
